import React from 'react'
import { connect } from 'react-redux'
import {
    getDecisionLogs,
    updateDecisionLog,
    getAllDecisionLogsFromServer,
} from 'src/store/modules/runbooks'
import * as BP from '@blueprintjs/core'
import AddDecisionDialog from 'src/routes/Runbook/Controls/Dialogs/AddDecisionDialog'
import { bindActionCreators } from 'redux'
import './style.scss'

const classNamePrefix = 'runbooks-decision-logs'

class DecisionLogs extends React.Component {
    state = {
        editingLog: null,
    }
    componentDidMount() {
        this.props.actions.getAllDecisionLogsFromServer(this.props.session)
    }
    handleEditDecisionClick(log) {
        this.setState({ editingLog: log })
    }
    handleEditDecisionClose(log) {
        this.setState({ editingLog: null })
    }
    renderDecisionLogs() {
        return this.props.decisionLogs.map((log) => (
            <BP.Card key={log.id} interactive elevation={BP.Elevation.TWO}>
                <div className={`${classNamePrefix}_tag-container`}>
                    <span className="uid">
                        {log.action ? <BP.Tag>{log.action.uid}</BP.Tag> : null}
                    </span>
                    <span className="action-name">
                        {log.action ? (
                            <BP.Tag intent={log.action ? 'danger' : ''}>
                                {log.action.name}
                            </BP.Tag>
                        ) : null}
                    </span>
                    <BP.Tag>{log.owner}</BP.Tag>
                </div>
                <div className={`${classNamePrefix}_content-container`}>
                    <span className="decision">
                        <span>Decision:</span> {log.decision}
                    </span>
                    <span className="reasoning">
                        <span>Reasoning:</span> {log.reasoning}
                    </span>
                </div>
                <span className="created-at">{log.createdAt}</span>
                <BP.Button
                    style={{ margin: 'auto 0 auto 0' }}
                    icon="edit"
                    onClick={() => {
                        this.handleEditDecisionClick(log)
                    }}
                />
            </BP.Card>
        ))
    }
    renderAddDecisionDialog() {
        let { id, owner, reasoning, decision, action } = this.state.editingLog
        return (
            <AddDecisionDialog
                id={id}
                owner={owner}
                reasoning={reasoning}
                decision={decision}
                fromAction={(action && action.uid) || null}
                handleConfirm={(data) => {
                    this.props.actions.updateDecisionLog(
                        this.props.session,
                        data
                    )
                }}
                handleClose={() => {
                    this.handleEditDecisionClose()
                }}
            />
        )
    }

    render() {
        if (!this.props.decisionLogs) return null
        let decisionLogs = this.renderDecisionLogs()
        let addDecisionDialog = this.state.editingLog
            ? this.renderAddDecisionDialog()
            : null
        return (
            <div className={classNamePrefix}>
                {decisionLogs}
                {addDecisionDialog}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    decisionLogs: getDecisionLogs(state),
    isEditingDecision: state.ui.runbook.controls.isInsertingDecision,
})

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                updateDecisionLog,
                getAllDecisionLogsFromServer,
            },
            dispatch
        ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DecisionLogs)
